import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '@security/authentication.service';
import { Clients } from '@models/clients';

interface TokenPayload {
  sub?: string;
  permissions?: string[];
}

@Injectable()
export class AuthorizationService {
  currentUserMail = '';

  constructor(private authenticationService: AuthenticationService) {}

  getPermissions(client: string = Clients.BRIDGET): Observable<string[]> {
    const token = this.authenticationService.getAccessToken();
    if (!token) {
      this.currentUserMail = '';
      return of([]);
    }
    const payload = this.decodeTokenPayload(token);
    this.currentUserMail = payload?.sub ?? '';
    const allPermissions = payload?.permissions ?? [];
    const appPrefix = client + '.';
    const permissions = allPermissions.filter((p) => p.startsWith(appPrefix)).map((p) => p.substring(appPrefix.length));
    return of(permissions);
  }

  hasBridgetPermission(permission: string): Observable<boolean> {
    return this.getPermissions(Clients.BRIDGET).pipe(map((p) => p.includes(permission)));
  }

  hasBridgetPermissions(permissions: string[]): Observable<boolean> {
    return this.getPermissions(Clients.BRIDGET).pipe(map((p) => p.some((perm) => permissions.includes(perm))));
  }

  hasJimboPermission(permission: string): Observable<boolean> {
    return this.getPermissions(Clients.JIMBO).pipe(map((p) => p.includes(permission)));
  }

  private decodeTokenPayload(token: string): TokenPayload | null {
    try {
      const parts = token.split('.');
      if (parts.length !== 3) {
        return null;
      }
      const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(atob(base64)) as TokenPayload;
    } catch {
      return null;
    }
  }
}
